import { CrmOption } from '@touch4it/ng-swp/common';
import { crmGetUserName } from '@touch4it/ng-swp/user';

import { User } from '../user';

export type UserOption = CrmOption<string, User>;

export const toUserOption = (user: User): UserOption => ({
  value: user._id as string,
  label: crmGetUserName(user),
  data: user,
});
